import { render, staticRenderFns } from "./dataEspecial.vue?vue&type=template&id=7ab95a21"
import script from "./dataEspecial.vue?vue&type=script&lang=js"
export * from "./dataEspecial.vue?vue&type=script&lang=js"
import style0 from "./dataEspecial.vue?vue&type=style&index=0&id=7ab95a21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports